import React, { Component } from "react";
import Linkify from "react-linkify";
import { getSocket } from "../../../socket";

import Core from "../../../Core";

import "./index.scss";

export default class Queue extends Component {
  constructor(props) {
    super(props);
    this.state = {
      queue: [],
    };
    this.container = React.createRef();
  }

  componentDidMount() {
    this.loadData();
    const that = this;
    getSocket().on("refreshQuestionBox", function () {
      that.loadData();
    });
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    this.update();
  }

  update() {
    const container = this.container.current;
    container.scrollTop = container.scrollHeight;
  }

  loadData() {
    Core.apiData(`question-box/${Core.data().arena}.json`, {
      onSuccess: (data) => {
        if (data.json) {
          let hasChange = false;
          for (const item of data.json) {
            let found = false;
            for (const question of this.state.queue) {
              if (item.uid == question.uid) {
                found = true;
                break;
              }
            }
            if (found == false) {
              hasChange = true;
              break;
            }
          }
          for (const question of this.state.queue) {
            let found = false;
            for (const item of data.json) {
              if (item.uid == question.uid) {
                found = true;
                break;
              }
            }
            if (found == false) {
              hasChange = true;
              break;
            }
          }
          if (hasChange) {
            this.setState({ queue: data.json });
          }
        } else {
          console.log("Question Box - Fail to fetch, data is not a json");
        }
      },
      onFail: (data) => {
        console.log("Question Box - Queue", data);
      },
    });
  }

  render() {
    const divs = [];
    const { queue } = this.state;
    let index = 1;
    for (const question of queue) {
      if (question.question) {
        divs.push(
          <div>
            <div
              className={`social-wall-queue__listitem ${
                index % 2 === 0
                  ? "social-wall-queue__listitem--red"
                  : "social-wall-queue__listitem--orange"
              }`}
            >
              <p
                className={`social-wall-queue__paragraph ${
                  index % 2 === 0
                    ? "social-wall-queue__paragraph--red"
                    : "social-wall-queue__paragraph--orange"
                }`}
              >
                <Linkify
                  componentDecorator={(decoratedHref, decoratedText, key) => (
                    <a target="_blank" href={decoratedHref} key={key}>
                      {decoratedText}
                    </a>
                  )}
                >
                  {question.question}
                </Linkify>
              </p>
            </div>
          </div>
        );

        index++;
      }
    }
    if (divs.length == 0) {
      divs.push(
        <div>
          <div className="social-wall-queue__listitem">
            {/* <p className="social-wall-queue__paragraph">As tuas questões serão enviadas para o moderador.</p> */}
          </div>
        </div>
      );
    }
    return (
      <div ref={this.container} className="social-wall-queue">
        {divs}
      </div>
    );
  }
}
